/**
 * Smallest ceiling above `rawMax` that divides into `tickCount` whole steps, so the
 * rendered axis labels stay round. Steps up once more when it lands exactly on
 * `rawMax`, leaving the tallest bar clear of the top gridline.
 *
 * `minUnit` floors the step's unit, so a small `rawMax` still gets whole-number ticks
 * instead of fractional ones.
 */
export const niceCeiling = (rawMax: number, tickCount: number, minUnit = 0): number => {
  if (rawMax <= 0) return tickCount;

  const unit = Math.max(minUnit, 10 ** Math.floor(Math.log10(rawMax / tickCount)));
  const increment = tickCount * unit;
  const ceiling = Math.ceil(rawMax / increment) * increment;

  return ceiling > rawMax ? ceiling : ceiling + increment;
};
